import * as React from "react";
import "react-datetime/css/react-datetime.css";
import ReactDatetimeClass, * as ReactDateTime from "react-datetime";
import moment, { isMoment } from "moment";
import { getValidDateFormat } from "../../utilities/dateUtils";

// Here, we are extending the props with renderInput. It has for sure been implemented but not included in type definitions for some reason.
export interface DatePickerProps extends ReactDateTime.DatetimepickerProps {
  renderInput?: (props: any, openCalendar: () => void, closeCalendar: () => void) => void;
}

export const DatePicker = (props: DatePickerProps) => {
  return <ReactDatetimeClass {...props} dateFormat={getValidDateFormat()} timeFormat={false} />;
};

export function formatDate(
  value: string | moment.Moment | React.FocusEvent<any>
): string | undefined {
  if (isMoment(value)) {
    const val = value as moment.Moment;
    return val.format(getValidDateFormat());
  }
  if (typeof value === "string") {
    const momentValue = moment(value, getValidDateFormat(), true);
    if (momentValue.isValid()) {
      return momentValue.format(getValidDateFormat());
    }
  }
}
